import script from "./AddInstructionUrlsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddInstructionUrlsModal.vue?vue&type=script&setup=true&lang=js"

import "./AddInstructionUrlsModal.vue?vue&type=style&index=0&id=e8b71904&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8b71904"]])

export default __exports__